<!-- Command Palette Overlay -->
<div class="palette-overlay" *ngIf="isOpen" (click)="close()">
  <div class="palette-container" (click)="$event.stopPropagation()">

    <!-- Search Input -->
    <div class="palette-search">
      <span class="search-icon">🔍</span>
      <input
        #searchInput
        type="text"
        class="search-input"
        placeholder="Search for pages, actions, or type a command..."
        [(ngModel)]="query"
        (ngModelChange)="onQueryChange($event)"
        autocomplete="off"
        spellcheck="false"
      />
      <span class="search-shortcut">Esc to close</span>
    </div>

    <!-- Results List -->
    <div class="palette-results" *ngIf="items.length > 0">
      <div
        *ngFor="let item of items; let i = index; trackBy: trackByItemId"
        class="palette-item"
        [class.selected]="i === selectedIndex"
        (click)="executeItem(item)"
        (mouseenter)="selectItem(i)"
      >
        <div class="item-icon">{{ item.icon }}</div>
        <div class="item-content">
          <div class="item-title">{{ item.title }}</div>
          <div class="item-subtitle" *ngIf="item.subtitle">{{ item.subtitle }}</div>
        </div>
        <div class="item-category" *ngIf="item.category">
          <span class="category-badge">{{ item.category }}</span>
        </div>
        <div class="item-action">
          <span class="action-icon">↵</span>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="palette-empty" *ngIf="items.length === 0 && query">
      <div class="empty-icon">🔍</div>
      <div class="empty-title">No results found</div>
      <div class="empty-subtitle">Try searching for a different page or action</div>
    </div>

    <!-- Footer -->
    <div class="palette-footer">
      <div class="footer-hints">
        <span class="hint">
          <kbd>↑</kbd> <kbd>↓</kbd> Navigate
        </span>
        <span class="hint">
          <kbd>Enter</kbd> Select
        </span>
        <span class="hint">
          <kbd>Esc</kbd> Close
        </span>
      </div>
    </div>

  </div>
</div>
